import appConfig from "@/utils/app-config";
import ApiRequest from "@/utils/api-request";
import devices from "devextreme/core/devices";

export default {

    processAuthData(data) {
        appConfig.sessionToken = data.session_token;
        appConfig.userId = data.user_id;
        appConfig.userIdent = data.user_ident;
        appConfig.userGroupId = data.user_group_id;
        appConfig.companyId = data.company_id;
        appConfig.isMobile = data.is_mobile;
        appConfig.startPath = data.start_path;

        if (appConfig.rememberMe)
            localStorage.setItem('sessionToken', appConfig.sessionToken);
        else
            localStorage.removeItem('sessionToken');
    },

    clearAuthData() {
        appConfig.sessionToken = null;
        appConfig.userId = null;
        appConfig.userGroupId = null;
        appConfig.companyId = null;
        appConfig.isMobile = false;
        appConfig.startPath = null;
        localStorage.removeItem('sessionToken');
    },

    loggedIn() {
        return appConfig.sessionToken && appConfig.userId;
    },

    uuidv4() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
        )
    },

    deviceUUID() {
        if (!localStorage.getItem('device_uuid')) {
            localStorage.setItem('device_uuid', this.uuidv4());
        }
        return localStorage.getItem('device_uuid');
    },

    async authenticate() {
        const me = this;

        appConfig.sessionToken = localStorage.getItem('sessionToken');
        if (!appConfig.sessionToken) return false;

        appConfig.rememberMe = true;

        return await ApiRequest.get('authenticate?session_token=' + appConfig.sessionToken + '&device_uuid=' + this.deviceUUID(), {},
            function (response) {
                if (response.status === 200) {
                    me.processAuthData(response.data);
                    return true;
                } else {
                    me.clearAuthData();
                    return false;
                }
            },
            function () {
                me.clearAuthData();
                return false;
            });
    },

    async logIn(company, username, password, rememberMe) {
        const me = this;

        appConfig.rememberMe = rememberMe;

        return ApiRequest.post('login', {
                company: company,
                username: username,
                pw: password,
                device_uuid: this.deviceUUID(),
                device_type: devices.current().deviceType,
            },
            {
                'Authorization': null
            },
            (response) => {
                if (response.status === 200) {
                    me.processAuthData(response.data);
                    return {
                        success: true
                    };
                } else {
                    return {
                        success: false,
                        message: 'cp' + response.status
                    };
                }
            },
            (response) => {
                return {
                    success: false,
                    message: 'cp' + response.status
                };
            });
    },

    async logOut() {
        this.clearAuthData();
    },

};
